import UserTable from 'dashboard/containers/UserTable';
import React from 'react';

const UserListDashboard: React.FC = () => <UserTable />;

export default UserListDashboard;
